import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { BaseButton } from '@ertelecom/ui-react/components/buttons/baseButton';

export const breakePoints = {
    desktop: '1750px',
    laptop: '1187px',
    tablet: '980px',
    mobile: '640px',
};

export const DomruInternet = styled.div`
    margin-bottom: -50px;
    width: 100%;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 110px 0;
    background-color: ${p => p.bgColor || 'transparent'};
`;

export const InnerContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    max-width: 1050px;
    min-width: 320px;
`;

export const ImgWrap = styled.div`
    width: 100%;
`;

export const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

export const Button = styled(BaseButton)`
    width: auto;
`;

export const List = styled.div`
    display: flex;
    flex-wrap: nowrap;
`;

export const ListItem = styled.div`
    flex: 0 1 33%;
    display: flex;
    flex-direction: column;
    margin-right: 3.65%;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const SectionTitle = styled.h2`
    margin-bottom: 60px;
    width: 100%;
    ${FONTS.H1};
    color: ${p => p.isLight
        ? COLORS.white
        : COLORS.black
    };
    text-align: center;

    @media(max-width: ${breakePoints.laptop}) {
        ${FONTS.H1};
    }

    @media(max-width: ${breakePoints.mobile}) {
        ${FONTS.H2};
        text-align: left;
    }
`;

export const DataTitle = styled.h3`
    width: 100%;
    margin-bottom: 20px;
    ${FONTS.H2};
    color: ${p => p.isLight
        ? COLORS.white
        : COLORS.black
    };

    @media(max-width: ${breakePoints.laptop}) {
        ${FONTS.H3};
        margin-bottom: 15px;
    };
`;

export const DataText = styled.div`
    width: 100%;
    white-space: initial;
    ${FONTS.S};
    color: ${p => p.isLight
        ? COLORS.white
        : COLORS.black
    };
`;

export const DataLink = styled.a`
    margin-top: 20px;
    color: ${COLORS.lightBlue};
    border-bottom: 1px solid ${COLORS.lightBlue};
    width: max-content;
    transition: color .3s ease,border-color .3s ease;

    &:hover {
        color: ${COLORS.lightRed};
        border-bottom: 1px solid ${COLORS.lightRed};
    }
`;

export const Description = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;
